var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable */
import * as React from "react";
import { useSwipeable } from "react-swipeable";
export var SwipeBlock = function (props) {
    var handlers = useSwipeable({
        onSwipedLeft: function (event) {
            props.detectSwipeDir(event.dir);
        },
        onSwipedRight: function (event) {
            props.detectSwipeDir(event.dir);
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });
    return (React.createElement("div", __assign({}, handlers), props.children));
};
